var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('el-form-item',{attrs:{"label":"提示内容"}},[_c('el-input',{attrs:{"size":"small","placeholder":"请设置提示内容"},model:{value:(_vm._option),callback:function ($$v) {_vm._option=$$v},expression:"_option"}})],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }